import * as React from "react";

import { useScrollToTop } from "../Common";

import {
  ReactCheckout2022Route,
  useReactCheckout2022Router,
} from "./providers";

import { AppLoading } from "./app-loading";
import { Footer } from "./footer";
import { Header } from "./header";
import { PageMyBag } from "./page-my-bag";
import { PageDeliveryDetails } from "./page-delivery-details";
import { DrawerCheckout2022 } from "./drawer-checkout-2022";
import { PagePayment } from "./page-payment";
import { HeaderDeliveryTouchpoint } from "./header-delivery-touchpoint";
import { PageSuccess } from "./page-success";
import { ReactCheckout2022BodyClasses } from "./body-classes";

export const Page: React.FunctionComponent = () => {
  useScrollToTop();
  return (
    <React.Fragment>
      <AppLoading />

      <ReactCheckout2022BodyClasses />

      <OrderingPortalMost anyOrderingRoute>
        <Header />
        <HeaderDeliveryTouchpoint />
      </OrderingPortalMost>

      <OrderingPortalMost route="mybag">
        <PageMyBag />
      </OrderingPortalMost>

      <OrderingPortalMost route="delivery-details">
        <PageDeliveryDetails />
      </OrderingPortalMost>

      <OrderingPortalMost route="payment">
        <PagePayment />
      </OrderingPortalMost>

      <OrderingPortalMost route="success">
        <PageSuccess />
      </OrderingPortalMost>

      <OrderingPortalMost anyOrderingRoute>
        <Footer />
      </OrderingPortalMost>

      <OrderingPortalMost anyOrderingRoute>
        <DrawerCheckout2022 />
      </OrderingPortalMost>
    </React.Fragment>
  );
};

interface OrderingPortalMostProps {
  route?: `${ReactCheckout2022Route}`;
  routes?: `${ReactCheckout2022Route}`[];
  anyOrderingRoute?: boolean;
}
const OrderingPortalMost: React.FunctionComponent<OrderingPortalMostProps> = (
  props
) => {
  const { currentRoute } = useReactCheckout2022Router();
  const aRouteICareAbout = React.useMemo(() => {
    if (
      props.anyOrderingRoute &&
      currentRoute !== ReactCheckout2022Route.success
    ) {
      return true;
    }

    let isThisThatRoute = false;
    if (props.route) {
      isThisThatRoute = currentRoute === props.route;
    }

    let isThisOneOfTheseRoutes = false;
    if (props.routes) {
      isThisOneOfTheseRoutes = props.routes.includes(currentRoute);
    }

    return isThisThatRoute || isThisOneOfTheseRoutes;
  }, [props.anyOrderingRoute, currentRoute, props.route, props.routes]);
  if (!aRouteICareAbout) {
    return null;
  }
  return <React.Fragment>{props.children || []}</React.Fragment>;
};
